var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('Tag',{staticClass:"tag-check",attrs:{"icon-left":_vm.icon,"color":_vm.color}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }